<div class="relative w-full h-full">
    <img
        class="object-contain md:object-cover w-full h-full bg-[#F5FEFF]"
        src="/assets/images/login-background.png"
        alt="login-background" />
    <div class="absolute inset-0">
        <router-outlet></router-outlet>
    </div>
</div>
